import { LoadingDots } from "PFComponents/loading_dots";
import NotFoundComponent from "PFComponents/not_found/not_found";
import { CSSProperties, ReactElement } from "react";

type PageWrapperProps = {
  children: ReactElement;
  isLoading?: boolean;
  loadingComponent?: ReactElement;
  isError?: boolean;
  errorComponent?: ReactElement;
  fade?: boolean;
  fadeStrength?: number;
  wrapperStyle?: CSSProperties;
};

export const PageWrapper = ({
  children,
  isLoading = false,
  loadingComponent = <LoadingDots circlesEnabled pageViewEnabled />,
  isError = false,
  errorComponent = <NotFoundComponent />,
  fade,
  fadeStrength = 0.5,
  wrapperStyle = {}
}: PageWrapperProps) => {
  if (isLoading && loadingComponent) {
    return loadingComponent;
  }

  if (isError && errorComponent) {
    return errorComponent;
  }

  return <div style={{ opacity: fade ? fadeStrength : 1, ...wrapperStyle }}>{children}</div>;
};
